import MasterSection from "@/components/Library/__MasterSection.vue";
//------------------------------------------------------------------------------------
import MasterLibrary from "@/components/Library/_MasterLibrary.vue";
import MasterPending from "@/components/Library/_MasterPending.vue";
import MasterSearch from "@/components/Library/_MasterSearch.vue";
import MasterDuplicates from "@/components/Library/_MasterDuplicates.vue";
//------------------------------------------------------------------------------------
import AdvancedSearchQuery from "@/components/Library/AdvancedSearch/Query.vue";
// import AdvancedSearchResults from "@/components/Library/AdvancedSearch/Results.vue";
import AdvancedSearchSubMenu from "@/components/Library/AdvancedSearch/SubMenu.vue";
// Left Menu : Boxes
import BoxListMenu from "@/components/Boxes/BoxMenuList.vue";
// Page sub menu
import PageSubMenuPending from "@/components/Library/_PageSubMenuPending.vue";
import PageSubMenuLibrary from "@/components/Library/_PageSubMenuLibrary.vue";
import PageSubMenuDuplicates from "@/components/Library/_PageSubMenuDuplicates.vue";
import PageSubMenuUncompleted from "@/components/Library/_PageSubMenuUncompleted.vue";

//------------------------------------------------------------------------------------
import TrackPendingList from "@/components/Library/TrackPendingList";
import TrackQuickList from "@/components/Library/TrackQuickList";
import TrackDuplicateList from "@/components/Library/TrackDuplicateList";
 
//------------------------------------------------------------------------------------
import Constants from '@/store/constants';
//------------------------------------------------------------------------------------
export default {
    path: '/:stationUid/library',
    components :{
        default: MasterSection,
        menu:BoxListMenu
    },
    children: [
        { 
            name: 'LibraryHome', 
            path: 'tracks',  
            redirect:"tracks/music",
            components:{
                default:MasterLibrary,
                pageSubMenu: PageSubMenuLibrary
            },
            children:[
                {
                    name: 'LibraryTracks', path: 'music', component: TrackQuickList,
                    props: {
                        pending: false, fileType: Constants.trackTypes.MUSIC
                    }
                },
                {
                    name: "LibraryJingles", path: 'jingle', component: TrackQuickList,
                    props: { pending: false, fileType: Constants.trackTypes.JINGLE },
                },
                {
                    name: "LibraryPodcasts", path: 'podcast', component: TrackQuickList,
                    props: { pending: false, fileType: Constants.trackTypes.PODCAST },
                },
                {
                    name: "LibraryPromos", path: 'promo', component: TrackQuickList,
                    props: { pending: false, fileType: Constants.trackTypes.PROMO },
                },
                {
                    name: "LibraryVoiceTrack", path: 'voice-track', component: TrackQuickList,
                    props: { pending: false, fileType: null }
                },
                {
                    name: "LibraryFillers", path: 'filler', component: TrackQuickList,
                    props: { pending: false, fileType: Constants.trackTypes.FILLER }
                },
            ]
        },
        {
            name: "LibraryPending", path: 'pending', 
            components:{
                default:MasterPending,
                pageSubMenu: PageSubMenuPending,
            },
            redirect: "pending/MUSIC" ,
       
            children:[
                { 
                    name: 'PendingHome', 
                    path: ':fileType', 
                    component:TrackPendingList 
                },
            ]
        },
        {
            name: "Uncompleted", path: 'uncompleted',
            components:{
                default:MasterPending,
                pageSubMenu: PageSubMenuUncompleted,
            },
            redirect: "uncompleted/MUSIC" ,

            children:[
                {
                    name: 'UncompletedHome',
                    path: ':fileType',
                    component:TrackPendingList
                },
            ]
        },
        {
            name: "LibraryDuplicates", path: 'duplicates', 
            components:{
                default:MasterDuplicates,
                pageSubMenu: PageSubMenuDuplicates,
            },
            redirect: "duplicates/MUSIC" ,
            children:[
                { 
                    name: 'DuplicatesHome', 
                    path: ':fileType', 
                    component:TrackDuplicateList 
                },
            ]
        },
        {
            name:'LibraryAdvancedSearchHome', path:'advanced-search', 
            redirect: "advanced-search/query" ,
            components:{
                default:MasterSearch,
                pageSubMenu: AdvancedSearchSubMenu,
            },
            children:[
                { 
                    name: 'LibraryAdvancedSearchQuery', path: 'query', 
                    component:  AdvancedSearchQuery
                },
                { 
                    name: 'LibraryAdvancedSearchResults', path: 'search', 
                    component: TrackQuickList,
                    props:{
                        isAdvancedSearch:true,fileType:"MUSIC",
                    }
                },
            ]
        }
        
    ]
};
